import { useUserMessageTextModel } from './useUserMessageTextModel.js'
import UserMessageTextView from './UserMessageTextView.jsx'

export default function UserMessageText(props) {
  return <UserMessageTextView {...useUserMessageTextModel(props)} />
}
